import React from 'react'
import CampaignWizard from '../../campaign-wizard/CampaignWizard'

function CreateEmailNewsletter() {
    const steps = [
        { id: 1, title: 'Select Template', subtitle: 'Choose a template or start blank', component: 'TemplateSelection' },
        { id: 2, title: 'Campaign Information', subtitle: 'Basic information', component: 'CampaignInformation' },
        { id: 3, title: 'Subject Line', subtitle: 'Subject Line for Newsletter', component: 'SubjectLine' },
        { id: 4, title: 'Content', subtitle: 'Main content of the newsletter', component: 'EmailContent' },
        { id: 5, title: 'Patient List', subtitle: 'Select patient that will receive newsletter', component: 'PatientList' },
        { id: 6, title: 'Complete', subtitle: 'Process the Campaign', component: 'Complete' }
    ]

    const handleSubmit = (formData) => {
        console.log('Email Newsletter submitted:', formData)
        // Navigate back to list page
        window.history.back()
    }

    return (
        <CampaignWizard
            title="Create Email Newsletter"
            description="Send regular updates and news to your patients via email."
            navigatePath="/newsletter/email"
            campaignType="email"
            steps={steps}
            onSubmit={handleSubmit}
        />
    )
}

export default CreateEmailNewsletter
